const middleware = {}

middleware['routeCheck'] = require('../middleware/routeCheck.js')
middleware['routeCheck'] = middleware['routeCheck'].default || middleware['routeCheck']

export default middleware
